import { render } from "./RssPage.vue?vue&type=template&id=bd1b83f4&scoped=true"
import script from "./RssPage.vue?vue&type=script&lang=js"
export * from "./RssPage.vue?vue&type=script&lang=js"

import "./RssPage.vue?vue&type=style&index=0&id=bd1b83f4&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/cia-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1b83f4"]])

export default __exports__